import { render, staticRenderFns } from "./grouping-actions.vue?vue&type=template&id=18754918&scoped=true"
import script from "./grouping-actions.vue?vue&type=script&lang=js"
export * from "./grouping-actions.vue?vue&type=script&lang=js"
import style0 from "./grouping-actions.vue?vue&type=style&index=0&id=18754918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18754918",
  null
  
)

export default component.exports